import { useIntl } from 'react-intl'
import { CrmDictType, CrmDictionaryItem, crmApi } from '../../../features/crm/crmApi'

// Анықтамалықтар из базы: подпись по коду, список для формы (активные + уже выбранные в старой записи)
export const useCrmDict = () => {
    const { locale } = useIntl()
    const { data: items = [] } = crmApi.useGetDictionaryQuery()
    const title = (i: CrmDictionaryItem) => (locale === 'ru' ? i.titleRu || i.titleKz : i.titleKz || i.titleRu) || i.code || ''
    const find = (type: CrmDictType, code?: string | null) => items.find((i) => i.type === type && i.code === code)
    const of = (type: CrmDictType) => items.filter((i) => i.type === type).sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
    return {
        items,
        of,
        title,
        find,
        label: (type: CrmDictType, code?: string | null) => {
            if (!code) return '-'
            const i = find(type, code)
            return i ? title(i) : code
        },
        list: (type: CrmDictType, codes?: string[] | null) =>
            (codes ?? [])
                .map((c) => {
                    const i = find(type, c)
                    return i ? title(i) : c
                })
                .join(', '),
        options: (type: CrmDictType, current?: string | string[] | null) => {
            const cur = ([] as string[]).concat(current ?? [])
            return of(type).filter((i) => i.active || cur.includes(i.code || ''))
        },
        isInstallment: (payType?: string | null) => !!payType && !!find('PAY_TYPE', payType)?.installment,
    }
}

export type CrmDict = ReturnType<typeof useCrmDict>
